import React from "react";
import BaseButtonToggle from "../../sisu/button/BaseButtonToggle.sisu"

const NeoBotonToggle = (props) => {
    return (<>
        <BaseButtonToggle custom="p-button-rounded p-button-outlined" {...props} />
    </>);
};

export default NeoBotonToggle;